import { useState, useEffect, useRef, RefObject } from "react";

function useIsScrolled(): [boolean, boolean, RefObject<HTMLDivElement>] {
	const [isScrolled, setIsScrolled] = useState(false);
	const [isAtEnd, setIsAtEnd] = useState(false);
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleScroll = () => {
			if (ref.current) {
				const { scrollTop, scrollHeight, clientHeight } = ref.current;
				setIsScrolled(scrollTop > 0);
				setIsAtEnd(scrollTop + clientHeight >= scrollHeight);
			}
		};

		const currentElement = ref.current;
		if (currentElement) {
			currentElement.addEventListener("scroll", handleScroll);
		}

		return () => {
			if (currentElement) {
				currentElement.removeEventListener("scroll", handleScroll);
			}
		};
	}, []);

	return [isScrolled, isAtEnd, ref];
}

export default useIsScrolled;
